var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"flex mb10"},[_c('span',[_vm._v(_vm._s(_vm.pre))]),_c('el-input',{staticClass:"w60",class:_vm.inputClass,attrs:{"size":"mini"},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}}),_c('span',[_vm._v(_vm._s(_vm.suf))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }